export const Consent = Object.freeze({
    status:
        {
            init: 'Consent.status.init',
            refused: 'Consent.status.refused',
            accepted: 'Consent.status.accepted',
        },
    validate:
        {
            submit: 'Consent.validate.submit'
        }
});